/**
 * Map an AI NavigationTarget to an SPA route. The server never knows routes -
 * this is the single place targets become URLs. Unknown/invalid targets return
 * null and the caller no-ops (older client vs newer server degrades safely).
 */

import type { NavigationTarget } from '@protoss/shared';

export function resolveNavigationTarget(target: NavigationTarget): string | null {
  switch (target.kind) {
    case 'deal':
      if (!target.dealUuid) return null;
      // Transcript hand-off (from /create-deal): open the editable questionnaire so the
      // deal page's auto-trigger can run analysis and the user can apply the results.
      return target.transcriptDocUuids?.length || target.transcriptDocUuid
        ? `/so/deal/${target.dealUuid}/edit`
        : `/so/deal/${target.dealUuid}`;
    case 'deal_create':
      return '/so/deal/new';
    case 'deal_list':
      return '/so/deals';
    case 'url': {
      // Same-origin relative paths only - never navigate the SPA to foreign URLs.
      const url = target.url ?? '';
      return url.startsWith('/') && !url.startsWith('//') ? url : null;
    }
    default:
      return null;
  }
}
